<template>
  <div
    class="d-flex"
    :style="!hasArrow ? `color:var(--clr-grey-2)` : ''"
  >
    <div class="text-nowrap">
      <i
        v-if="hasArrow"
        class="td_icon mdi mdi-menu-up"
      />
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudyPlayersTableRowBox',
  props: {
    hasArrow: { type: Boolean, default: true },
  },
}
</script>

<style lang="scss" scoped>
.td_icon {
  margin-left: -0.25rem;
  margin-right: -0.125rem;
}
.td {
  &_value {
    &_up {
      color: var(--clr-primary);
    }
    &_down {
      color: var(--clr-error);
      .td_icon {
        &:before {
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>
